// eslint-disable-next-line spaced-comment
/// <reference types="@hcaptcha/types"/>

const _hcaptchaPromise: Promise<HCaptcha> = new Promise((resolve) => {
  if (window.hcaptcha) {
    resolve(window.hcaptcha);
  }

  // hcaptcha will sometimes console.log a warning if the load fn doesn't
  // exist, so just always defined it even if we've already resolved above.
  // @ts-expect-error TS2339
  window.captchaLoad = () => {
    resolve(window.hcaptcha);
  };
});
const hcaptchaPromise = () => _hcaptchaPromise;

export default hcaptchaPromise;
